'use client';

import React, { memo } from 'react';
import Image from 'next/image';

interface AppLogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'full' | 'icon';
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  size = 'md',
  variant = 'full',
  className = '',
  onClick,
}: AppLogoProps) {
  const dims = {
    sm: { w: 160, h: 64 },
    md: { w: 220, h: 88 },
    lg: { w: 290, h: 116 },
  }[size];

  // Icon-only: show a small square crop of the logo
  if (variant === 'icon') {
    const s = size === 'sm' ? 44 : size === 'md' ? 56 : 72;
    return (
      <div
        className={`flex items-center justify-center flex-shrink-0 ${onClick ? 'cursor-pointer' : ''} ${className}`}
        onClick={onClick}
        style={{ width: s, height: s }}
      >
        <Image
          src="/assets/images/CFVA-logo-tagline-1775363438977.png"
          alt="CFVA Logo"
          width={s}
          height={s}
          style={{ objectFit: 'contain', width: s, height: s }}
          priority
        />
      </div>
    );
  }

  // Full logo
  return (
    <div
      className={`flex items-center flex-shrink-0 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
      style={{ width: dims.w, height: dims.h }}
    >
      <Image
        src="/assets/images/CFVA-logo-tagline-1775363438977.png"
        alt="Central Florida Vocal Arts Logo"
        width={dims.w}
        height={dims.h}
        style={{ objectFit: 'contain', width: dims.w, height: dims.h }}
        priority
      />
    </div>
  );
});

export default AppLogo;
